import { connect } from 'react-redux';
import { updateOrder } from 'Actions/form'
import ReviewAndSubmit from './Review_and_Submit';

const mapStateToProps = (state) => ({
    order: state.form.order,
    
    firstName: state.payment.firstName,
    lastName: state.payment.lastName,
    email: state.payment.email,
    phone: state.payment.phone,
    deliveryOption: state.payment.deliveryOption,

    shipCountry: state.shipping.country,
    shipProvinceState: state.shipping.provinceState,
    shipCity: state.shipping.city,
    shipAddress: state.shipping.address,
    shipPostalCode: state.shipping.postalCode,
    shipLocation: state.payment.storeLocation,

    allLocations: state.form.shippingLocations,
    concessionData: state.form.concessionInfo,

    valids: state.form.valids
})

const mapDispatchToProps = (dispatch) => ({
    updateOrder: (new_order) => dispatch(updateOrder(new_order)),
})

export default connect (mapStateToProps, mapDispatchToProps)(ReviewAndSubmit);